<template>
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <h2>
          알림톡 발신번호 관리
        </h2>
        <p class="gray">발신번호를 등록합니다.</p>
      </div>
    </div>

    <el-row :gutter="40">
      <el-col :span="12">
        <div class="d-flex with-button">
          <div class="p-2 small bottom">
            총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
          </div>
          <div class="ml-auto p-2">
            <button type="button" class="btn gray" @click="retrieveCallback">API STORE 발신번호 업데이트</button>
            <button type="button" class="btn mint" @click="retrieve">조회</button>
          </div>
        </div>
        <stone-data-table
          :loading="searchLoading"
          :columns="tableColumns"
          :data="tableData"
          :table-props="tableProps">
        </stone-data-table>
      </el-col>
      <el-col :span="12">
        <el-form :model="frm" :rules="rules" ref="frm" label-width="120px" class="demo-form">
          <div class="card-body gray">
            <el-form-item label="인증방식" prop="pintype">
              <el-select v-model="frm.pintype" placeholder="인증방식을 선택하십시오.">
                <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="코멘트" prop="comment">
              <el-input v-model.trim="frm.comment" :maxlength="30" placeholder="코멘트를 입력하십시오."></el-input>
            </el-form-item>
            <el-form-item label="발신번호" prop="sendnumber">
              <el-input v-model.trim="frm.sendnumber" :maxlength="11" placeholder="- 없이 입력하십시오."></el-input>
              <el-button type="primary" @click="requestCallback">인증요청</el-button>
            </el-form-item>
            <el-form-item label="인증번호" prop="pincode">
              <el-input v-model.trim="frm.pincode" :disabled="isDisabled" :maxlength="frm.pintype === 'SMS' ? 6 : 2" :placeholder="pincodePlaceholder"></el-input>
              <el-button type="danger" :disabled="isDisabled" @click="confirmCallback">인증 확인</el-button>
              <countdown v-if="!isDisabled" :time="timer">
                <template slot-scope="props">남은 시간 {{`${props.minutes} : ${props.seconds}`}}</template>
              </countdown>
            </el-form-item>

            <ul>
              <li>* 기본 : 8자리 ~ 11자리 발신번호<li>
              <li>* 유선 전화번호 : 지역 번호를 포함</li>
              <li>* 이동통신 전화번호</li>
              <li>* 대표 전화번호 : 15xx, 16xx, 18xx (번호 앞에 지역번호 사용금지)</li>
            </ul>

          </div>

          <div class="card-body text-right">
            <!-- <el-button @click="resetForm('cgform')">취소</el-button> -->
          </div>
        </el-form>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import common from '@/modules/common'
import VueCountdown from '@xkeshi/vue-countdown'
export default {
  name: 'M990702',
  mixins: [common.mixins],
  components: {countdown: VueCountdown},
  computed: {
    pincodePlaceholder: function () {
      return this.frm.pintype === 'SMS' ? 'SMS 인증번호 (6자리)' : 'VMS 인증번호 (2자리)'
    }
  },
  data () {
    return {
      tableProps: {height: this.getScreenHeight(43)},
      tableData: [],
      tableColumns: [
        {label: 'No', type: 'index', align: 'left'},
        {label: '코멘트', prop: 'send_comment', align: 'left'},
        {label: '발신번호', prop: 'send_number', align: 'center', formatter: this.columnFormatterPhone}
      ],
      isDisabled: true,
      frm: {
        sendnumber: '',
        pintype: 'SMS',
        pincode: '',
        comment: ''
      },
      timer: 0,
      options: [{label: 'SMS', value: 'SMS'}, {label: 'VMS (음성)', value: 'VMS'}],
      rules: {
        sendnumber: [
          { required: true, message: '발신 전화번호를 입력하십시오.', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          { min: 8, max: 11, message: '최소 8자 이상 최대 11자까지 입력하십시오.' }
          // { type: 'string', pattern: /^01([0|1|6|7|8|9]?)-?(\d{3,4})-?(\d{4})$/, message: '전화번호 형식에 맞지 않습니다.' }
        ],
        pintype: [
          { required: true, message: '인증방식을 선택하십시오.', trigger: 'change' }
        ],
        pincode: [
          { required: false, message: '인증번호를 입력하십시오.' },
          { min: 2, max: 6, message: '인증 번호는 최소 2자 이상 최대 6자입니다.' }
        ],
        comment: [
          { required: true, message: '코멘트를 입력하십시오.' }
        ]
      }
    }
  },
  created () {
    this.retrieve()
  },
  methods: {
    retrieve () {
      common.axios.post('/kakao/callback/list', {})
        .then(response => {
          this.tableData = response.data
          // console.log(this.tableData)
        })
    },
    retrieveCallback () {
      common.axios.post('/kakao/sendnumber/list', {})
        .then(response => {
          // console.log('response : ', response.data)
          if (response.data.status === 1) {
            this.$message('발신번호 정보를 업데이트 하였습니다.')
            this.retrieve()
          }
        })
    },
    requestCallback () {
      this.$refs.frm.validate(valid => {
        if (valid) {
          common.axios.post('/kakao/sendnumber/request', this.frm)
            .then(response => {
              const result = response.data
              if (result.result_code === '200') {
                this.$alert('인증번호가 발송되었습니다. 3분이내에 인증번호를 입력하십시오.')
                this.isDisabled = false
                this.timer = 3 * 60 * 1000
              } else if (result.result_code === '400') {
                this.$alert('인증 업데이트 중 에러입니다.')
              } else if (result.result_code === '500') {
                this.$alert('이미 등록된 번호입니다.')
              } else {
                this.$alert(result.result_code)
              }
            })
        }
      })
    },
    confirmCallback () {
      if (!this.frm.pincode) {
        this.$alert('인증번호를 입력하십시오.')
        return
      }
      common.axios.post('/kakao/sendnumber/confirm', this.frm)
        .then(response => {
          const result = response.data
          if (result.result_code === '200') {
            this.$alert('발신번호가 등록되었습니다.')
            this.frm.sendnumber = ''
            this.frm.comment = ''
            this.frm.pincode = ''
            this.isDisabled = true
            this.retrieveCallback()
          } else if (result.result_code === '600') {
            this.$alert('일치하지 않는 인증번호입니다.')
          } else if (result.result_code === '700') {
            this.$alert('핀코드 인증시간이 만료되었습니다. 인증번호를 다시 요청하십시오.')
            this.frm.sendnumber = ''
            this.frm.comment = ''
            this.frm.pincode = ''
            this.isDisabled = true
          } else {
            this.$alert(result.result_code)
          }
        })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M990702.vue